// extracted by mini-css-extract-plugin
export default {"spanrow":"Dashboardtable_spanrow__uwmmM","Head":"Dashboardtable_Head__m12NO","HeadLeft":"Dashboardtable_HeadLeft__mqAmJ","codeColumn":"Dashboardtable_codeColumn__8bcMZ"};